import { useState } from 'react';
import { debounce } from 'lodash';

import * as Constants from '../constants';

interface QueryParams {
  page: number;
  perPage: number;
}

interface InfiniteScroll {
  debounceHandleQuery: (query: string, status?: string | undefined, date?: string | null) => void;
  isLoading: boolean;
  pageParams: QueryParams;
  handlePagination: () => void;
  resetParams: () => void;
}

export const useInfiniteTableScroll = (): InfiniteScroll => {
  const [pageParams, setQueryParams] = useState<QueryParams>({
    page: 1,
    perPage: Constants.ITEM_LIMIT_PER_PAGE,
  });
  const [isLoading, setIsLoading] = useState(true);
  const debounceHandleQuery = debounce(handleQuery, 400);

  const handlePagination = () => {
    setQueryParams((prevQueryParams) => ({
      perPage: Constants.ITEM_LIMIT_PER_PAGE,
      page: prevQueryParams.page + 1,
    }));
  };

  const resetParams = () => {
    setQueryParams(() => ({
      perPage: Constants.ITEM_LIMIT_PER_PAGE,
      page: 1,
    }));
  };

  function handleQuery(query) {
    if (!query || query.length >= Constants.MINIMUM_SEARCH_STRING_LENGTH) {
      // reset scroll so it doesn't trigger the infinite scrolling
      window.scrollTo(0, 0);
      // cancel the last ongoing promise
      setIsLoading(true);
      setQueryParams((prevQueryParams) => ({
        page: 1,
        perPage: prevQueryParams.perPage,
      }));
    }
  }

  return {
    debounceHandleQuery,
    pageParams,
    isLoading,
    resetParams,
    handlePagination,
  };
};
